"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_i18next_1 = require("react-i18next");
const LocationMarkup = ({ location, schemaType, publicAccess }) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
    const { i18n } = (0, react_i18next_1.useTranslation)();
    const hasMapParams = (0, react_1.useMemo)(() => {
        //Generate hasMap url
        const destination = (location.lat && location.lng)
            ? `${location.lat}, ${location.lng}`
            : `${location.name}, ${location.address1}, ${location.address2
                ? `${location.address2}, `
                : ""}${location.city}, Ontario  ${location.postal}`;
        return new URLSearchParams({ api: "1", hl: i18n.language, destination }).toString();
    }, [location, i18n.language]);
    return ((0, jsx_runtime_1.jsx)("script", Object.assign({ type: "application/ld+json" }, { children: `
        {
        "@context": "http://schema.org",
        "@type": "${schemaType}",
        "name": "${(_a = location.name) !== null && _a !== void 0 ? _a : ''}",
        "address": {
          "@type": "PostalAddress",
          "addressLocality": "${(_b = location.city) !== null && _b !== void 0 ? _b : ''}",
          "addressRegion": "Ontario",
          "addressCountry": "Canada",
          "postalCode": "${(_c = location.postal) !== null && _c !== void 0 ? _c : ''}",
          "streetAddress": "${(_d = location.address1) !== null && _d !== void 0 ? _d : ''} ${(_e = location.address2) !== null && _e !== void 0 ? _e : ''}"
        },
        "geo": {
          "@type": "GeoCoordinates",
          "latitude": "${(_f = location.lat) !== null && _f !== void 0 ? _f : ''}",
          "longitude": "${(_g = location.lng) !== null && _g !== void 0 ? _g : ''}"
        },
        "latitude": "${(_h = location.lat) !== null && _h !== void 0 ? _h : ''}",
        "longitude": "${(_j = location.lng) !== null && _j !== void 0 ? _j : ''}",
        "branchCode": "${(_k = location.id) !== null && _k !== void 0 ? _k : ''}",
        "hasMap": "https://www.google.com/maps/dir/?${hasMapParams}",
        "publicAccess": ${publicAccess !== null && publicAccess !== void 0 ? publicAccess : ''},
        "url": "${(_l = location.website) !== null && _l !== void 0 ? _l : ''}",
        "telephone": "${(_m = location.phone) !== null && _m !== void 0 ? _m : ''}"
        }
    ` })));
};
exports.default = LocationMarkup;
